import { Fulfillment } from './Fulfillment';
import { Identifiers } from './Identifiers';

export const Product = {
  isBrowseOnly: ({ fulfillment, availabilityType }) => {
    if (!fulfillment || !availabilityType) return null;

    const fulfillable = !!((fulfillment?.fulfillmentOptions || []).find((option) => option.fulfillable));
    const availableOnline = availabilityType?.type === 'Online';

    return availableOnline && !fulfillable;
  },
  fulfillmentMethod: ({ fulfillment, identifiers }) => {
    if (!fulfillment || !identifiers) return null;

    if (Fulfillment.isSTH(fulfillment)) {
      return 'ShipToHome';
    }
    if (Fulfillment.isBOPIS(fulfillment)) {
      return 'BOPIS';
    }
    if (Fulfillment.isBOSS(fulfillment)) {
      return 'ShipToStore';
    }
    if (Identifiers.isAppliance(identifiers)) {
      return 'DirectDelivery';
    }
    if (Fulfillment.isBODFS(fulfillment)) {
      return 'DeliverFromStore';
    }
    return 'ShipToHome';
  }
};